var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRowVerticalDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.6 14.25H20.4C21.0651 14.25 21.3366 14.3949 21.4662 14.5327C21.6067 14.6819 21.75 15.0003 21.75 15.73V19.77C21.75 20.4997 21.6067 20.8181 21.4662 20.9673C21.3366 21.1051 21.0651 21.25 20.4 21.25H4.6C3.93486 21.25 3.66336 21.1051 3.53376 20.9673C3.39334 20.8181 3.25 20.4997 3.25 19.77V15.73C3.25 15.0003 3.39334 14.6819 3.53376 14.5327C3.66336 14.3949 3.93486 14.25 4.6 14.25Z",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6 2.75H20.4C21.0651 2.75 21.3366 2.8949 21.4662 3.03265C21.6067 3.18191 21.75 3.50032 21.75 4.23V8.27C21.75 8.99969 21.6067 9.31809 21.4662 9.46735C21.3366 9.6051 21.0651 9.75 20.4 9.75H4.6C3.93486 9.75 3.66336 9.6051 3.53376 9.46735C3.39334 9.31809 3.25 8.99969 3.25 8.27V4.23C3.25 3.50032 3.39334 3.18191 3.53376 3.03265C3.66336 2.8949 3.93486 2.75 4.6 2.75Z",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRowVerticalDark);
export default __webpack_public_path__ + "static/media/row-vertical-dark.9b035c06eedb9fda0904721c38f64fdc.svg";
export { ForwardRef as ReactComponent };